import { useEffect } from 'react';

export default function PortalRedirect() {
  useEffect(() => {
    // Redirect to Krayin CRM portal
    window.location.href = 'https://raha-iduu.ainaeco.uk/admin/login';
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-luxury-navy">
      <div className="text-center">
        <h1 className="text-4xl font-bold text-luxury-cream mb-4">Redirecting to CRM...</h1>
        <p className="text-luxury-warmGray mb-8">Taking you to the client portal.</p>
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-luxury-gold mx-auto"></div>
      </div>
    </div>
  );
}
